var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122687710485615601270000008692214369495969946_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "m0 0h64v64h-64z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000122687710485615601270000008692214369495969946_)",
    d: "m21.244 53.554c-2.547 0-5.094-.965-7.036-2.896-1.893-1.883-2.937-4.391-2.941-7.061-.003-2.67 1.034-5.181 2.922-7.069l23.995-23.994c2.787-2.788 7.324-2.789 10.113 0 2.788 2.788 2.788 7.326 0 10.114l-17.984 17.984c-1.688 1.686-4.432 1.687-6.118 0-1.687-1.688-1.686-4.433 0-6.118l11.99-11.989c.586-.586 1.535-.586 2.121 0s.586 1.536 0 2.121l-11.99 11.989c-.517.517-.517 1.358 0 1.876s1.357.516 1.875 0l17.983-17.984c1.618-1.619 1.618-4.253 0-5.872-1.619-1.618-4.252-1.618-5.871 0l-23.993 23.994c-1.32 1.32-2.046 3.076-2.043 4.944.003 1.867.733 3.621 2.057 4.937 2.719 2.706 7.14 2.699 9.855-.014l23.994-23.994c.586-.586 1.535-.586 2.121 0 .586.585.586 1.536 0 2.121l-23.994 23.995c-1.944 1.943-4.5 2.916-7.056 2.916z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.f5bd58c14cf6d4384e74d028b86d8fc2.svg";
export { ForwardRef as ReactComponent };